import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "D:\\dev\\danchudoba\\node_modules\\next\\dist\\client\\app-dir\\link.js");
